import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type BenefitPaymentsFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const BenefitPaymentsFilled = forwardRef<SVGSVGElement, BenefitPaymentsFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(0.25 0.249853) scale(0.734375)">
        <path d="M29.437 28.8002H2.56296C1.14748 28.8002 0 27.6527 0 26.2372V5.7602C0 5.73252 0.00044 5.70492 0.00132 5.67744C0.0426 4.37804 1.13032 3.35576 2.43036 3.3486L29.44 3.2002C30.8538 3.2002 32 4.34636 32 5.7602V12.7972C32 12.7989 31.9987 12.8002 31.997 12.8002H19.8925C17.733 12.8002 15.958 14.5588 16.0008 16.7178C16.0421 18.8028 17.7452 20.4802 19.84 20.4802H31.997C31.9987 20.4802 32 20.4815 32 20.4832V26.2372C32 27.6527 30.8525 28.8002 29.437 28.8002ZM17.2805 16.8124C17.2517 15.3717 18.4414 14.2002 19.8824 14.2002H31.997C31.9987 14.2002 32 14.2015 32 14.2032V19.3172C32 19.3189 31.9987 19.3202 31.997 19.3202H19.84C18.4436 19.3202 17.3083 18.2022 17.2805 16.8124ZM21.12 16.6402C21.12 15.9333 20.5469 15.3602 19.84 15.3602C19.1331 15.3602 18.56 15.9333 18.56 16.6402C18.56 17.3471 19.1331 17.9202 19.84 17.9202C20.5469 17.9202 21.12 17.3471 21.12 16.6402Z" />
      </g>
    </svg>
  ),
);

BenefitPaymentsFilled.displayName = 'BenefitPaymentsFilled';

export default BenefitPaymentsFilled;
